import { useContext, useState } from "react";
import { BannerLegal } from "@components/Images";
import { BannerLegalMov } from "@components/Images";
import CheckCircle from "@assets/icons/CheckCircle.svg";
import axios from "@fetch/axios"
import { TokenContext } from "@context/TokenContext";
import { useTranslation } from "@hooks/useTranslation";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { LanguageCurrencyContext } from "@context/LanguageCurrencyContext";

const Component = () => {
  const [showModal, setShowModal] = useState(false);
  const [name, setNombre] = useState(null)
  const [email, setEmail] = useState(null)
  const [message, setMessage] = useState(null)
  const { getToken } = useContext(TokenContext);
  const { translate } = useTranslation();
  const MySwal = withReactContent(Swal)
  const { lang } = useContext(LanguageCurrencyContext);

  const handleSubmit = async () => {

    if (!name || !email || !message) {

      MySwal.fire({
        text: translate('error.field'),
        icon: 'error',
        title: 'Oops...'
      })
      return;
    }

    try {
      const res = await axios.post(
        `/contact/send?lang=${lang}`,
        {
          "name": name,
          "email": email,
          "message": message
        },
        {
          headers: { 'Authorization': 'Bearer ' + getToken() }
        }
      );
      if (res.data.errors) {
        MySwal.fire({
          text: res.data.message,
          icon: 'success',
        })
      } else {

        setEmail('')
        setNombre('')
        setMessage('')
        setShowModal(true);
      }
    } catch (error) {
      MySwal.fire({
        text: error.response.data.message,
        icon: 'error',
        title: 'Oops...'

      })

    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };



  return (
    <>
      <section className="ArticleStaticLegal Contacto ImageButton pt-tophead">
        <article className="ImageButtonBG" >
          <picture>
            <source media="(max-width:700px)" srcSet={BannerLegalMov} type="image/webp" />
            <img src={BannerLegal} alt="" />
          </picture>
          <div>
            <div>
              <div className="ButtonContent ButtonDark">{translate('form.title')} </div>
            </div>
          </div>
        </article>
        <article className="ContactoBox">
          <div>
            <h5>{translate('form.message')}</h5>
            <label className="FormData">
              <em className="RequiredData">{translate('form.name')}</em>
              <div className="FormInputLight">
                <input placeholder={translate('form.name')} onChange={(e) => { setNombre(e.target.value.replace(/[^a-zA-ZñÑáéíóúÁÉÍÓÚ\s]/g, '')) }} value={name} />
              </div>
            </label>
            <label className="FormData">
              <em className="RequiredData">{translate('form.email')}</em>
              <div className="FormInputLight">
                <input 
                  placeholder={translate('form.email')} 
                  onChange={(e) => { 
                    const value = e.target.value;
                    // Solo permite letras, números y caracteres específicos de email
                    const sanitizedValue = value.replace(/[^a-zA-Z0-9@._%+-]/g, '');
                    setEmail(sanitizedValue);
                  }} 
                  value={email} 
                  type="email"
                  onBlur={(e) => {
                    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                    if (e.target.value && !emailRegex.test(e.target.value)) {
                      MySwal.fire({
                        text: translate('error.email'),
                        icon: 'error',
                        title: 'Oops...'
                      });
                      setEmail('');
                    }
                  }}
                />
              </div>
            </label>
            <label className="FormData">
              <em className="RequiredData">{translate('form.msj')}</em>
              <div className="FormInputLight">
                <textarea placeholder={translate('form.msj')} onChange={(e) => { setMessage(e.target.value.replace(/[^a-zA-ZñÑáéíóúÁÉÍÓÚ\s.,;:?!¡¿´0-9\-@]/g, '')); }} value={message} />
              </div>
            </label>
            <div
              className="ButtonContent ButtonDarkMedium"
              onClick={() => { handleSubmit() }}
            >
              {translate('form.send')}
            </div>
          </div>
          <div className="TextCenter">
            <b className="FontNormal">{translate('form.follow')}</b>
            <div>
              <a href="https://www.facebook.com/profile.php?id=61570059507003" target="__blank"><i className="icon-Facebook"></i></a>
              <a href="https://www.instagram.com/arteonu/" target="__blank"><i className="icon-Instagram"></i></a>
              {/* <i className="icon-Tiktok"></i>
              <i className="icon-X"></i> */}
            </div>
          </div>
        </article>
      </section>

      {/* Modal de agradecimiento */}
      {showModal && (
        <div className="ModalGracias">
          <div className="ModalContent">
            <i className="icon-Closed" onClick={handleCloseModal}></i>
            <div className="icon-Check"><img src={CheckCircle} alt="" /></div>
            <h4>{translate('form.text2')}</h4>
           
            <div className="ButtonDarkMedium" onClick={handleCloseModal}>{translate('form.accep')}</div>
          </div>
        </div>
      )}

    </>
  );
};

export default Component;